import React from 'react';
import { DashboardLayout } from './components/layout/DashboardLayout';
export function App() {
  return <DashboardLayout data-id="element-0" />;
}